"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("./fetch-JSON/fetch-JSON"), exports);
//# sourceMappingURL=index.js.map